/**
 * cf-cart-enhance.js — Ceinture Form
 * ---------------------------------------------------------------------------
 * 1. Ouvre + rafraîchit le mini-cart NATIF du thème après n'importe quel ajout
 *    au panier (y compris le bouton "Sticky Add to Cart" de Zoorix qui appelle
 *    /cart/add directement). On appelle les méthodes publiques du custom element
 *    <mini-cart> : getItems() (relit /cart.js + reconstruit) puis openModal().
 * 2. Bannière d'urgence dynamique dans le drawer : injectée dans .soa-urgency-slot
 *    et mise à jour à chaque reconstruction de .mini-cart__items (MutationObserver).
 *
 * 100% additif, enveloppé dans des try/catch pour ne jamais bloquer le panier.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var MIN = 4, MAX = 8;
  var lastOpen = 0;

  var ICON =
    '<svg viewBox="0 0 56 56" width="46" height="46" xmlns="http://www.w3.org/2000/svg">' +
    '<circle cx="28" cy="28" r="26.5" fill="#EAF7EA" stroke="#BFE6BF" stroke-width="1.5"/>' +
    '<g fill="none" stroke="#32CD32" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M28 13.5 L40 19.5 V33 L28 39 L16 33 V19.5 Z"/>' +
    '<path d="M16 19.5 L28 25.5 L40 19.5"/>' +
    '<path d="M28 25.5 V39"/></g>' +
    '<circle cx="39.5" cy="38" r="8" fill="#32CD32" stroke="#EAF7EA" stroke-width="2"/>' +
    '<path d="M39.5 34.5 V38.2" stroke="#fff" stroke-width="2" stroke-linecap="round"/>' +
    '<circle cx="39.5" cy="41" r="1.1" fill="#fff"/></svg>';

  function count(seed) { var n = Math.abs(parseInt(seed, 10)) || 0; return MIN + (n % (MAX - MIN + 1)); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function decodeEntities(s) { try { var t = document.createElement('textarea'); t.innerHTML = String(s); return t.value; } catch (e) { return String(s); } }
  function getMiniCart() { return document.querySelector('mini-cart'); }

  // --- Bannière d'urgence : remplit .soa-urgency-slot depuis le 1er article rendu ---
  function updateUrgency() {
    try {
      var slot = document.querySelector('.soa-urgency-slot');
      if (!slot) return;
      var firstItem = document.querySelector('.mini-cart__items .mini-cart__item');
      if (!firstItem) { slot.innerHTML = ''; slot.removeAttribute('data-key'); return; }
      var titleEl = firstItem.querySelector('.mini-cart__item-title');
      var title = titleEl ? decodeEntities(titleEl.textContent.trim()) : '';
      var seed = firstItem.dataset.variantId || '';
      var key = seed + '|' + title;
      if (slot.getAttribute('data-key') === key) return;
      slot.setAttribute('data-key', key);
      slot.innerHTML =
        '<div class="soa-urgency">' +
          '<span class="soa-urgency__ic" aria-hidden="true">' + ICON + '</span>' +
          '<div class="soa-urgency__body">' +
            '<p class="soa-urgency__main">Plus que <span class="soa-urgency__count">' + count(seed) +
            '</span> exemplaires disponibles pour <span class="soa-urgency__product">' + esc(title) + '</span></p>' +
            '<p class="soa-urgency__sub">Ne passez pas à côté, commandez maintenant.</p>' +
          '</div>' +
        '</div>';
    } catch (e) {}
  }

  // --- Corrige les titres d'articles encodés (bug thème : entités affichées littéralement) ---
  function fixTitles() {
    try {
      var titles = document.querySelectorAll('.mini-cart__items .mini-cart__item-title');
      for (var i = 0; i < titles.length; i++) {
        var raw = titles[i].textContent;
        if (raw && raw.indexOf('&') !== -1) {
          var dec = decodeEntities(raw);
          if (dec !== raw) titles[i].textContent = dec;
        }
      }
    } catch (e) {}
  }

  function refresh() { fixTitles(); updateUrgency(); }

  function observeItems() {
    try {
      var mc = getMiniCart();
      if (!mc || mc.__cfObserved) return;
      var items = mc.querySelector('.mini-cart__items');
      if (!items) return;
      mc.__cfObserved = true;
      var obs = new MutationObserver(function () { setTimeout(refresh, 30); });
      obs.observe(items, { childList: true });
      refresh();
    } catch (e) {}
  }

  // --- Ouvrir + rafraîchir le mini-cart après un ajout ---
  function openCart() {
    try {
      if (Date.now() - lastOpen < 600) return;
      lastOpen = Date.now();
      var mc = getMiniCart();
      if (mc && typeof mc.getItems === 'function') {
        mc.getItems();
        mc.openModal();
      }
    } catch (e) {}
  }

  function isAdd(url) { return typeof url === 'string' && url.indexOf('/cart/add') !== -1; }

  // Interception fetch
  try {
    if (typeof window.fetch === 'function') {
      var origFetch = window.fetch;
      window.fetch = function () {
        var args = arguments, url;
        try { url = args[0] && typeof args[0] === 'object' ? args[0].url : args[0]; } catch (e) {}
        var promise = origFetch.apply(this, args);
        try {
          if (isAdd(url) && promise && typeof promise.then === 'function') {
            promise.then(function (r) {
              try { if (r && (r.ok || r.status === 200)) setTimeout(openCart, 150); } catch (e) {}
            }).catch(function () {});
          }
        } catch (e) {}
        return promise;
      };
    }
  } catch (e) {}

  // Interception XHR
  try {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__cfAdd = isAdd(url); } catch (e) {}
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      try {
        if (this.__cfAdd) {
          this.addEventListener('load', function () {
            try { if (this.status >= 200 && this.status < 300) setTimeout(openCart, 150); } catch (e) {}
          });
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  } catch (e) {}

  function start() { observeItems(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 300); });
  } else {
    setTimeout(start, 300);
  }
  setTimeout(start, 1500);
})();
